import { Component, OnInit } from '@angular/core';
import { Costcenter } from '../costcenter';
import { CostcenterService } from '../costcenter.service';
import { User } from '../../user/user';
import { UserService } from '../../user/user.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrManager } from 'ng6-toastr-notifications';
import { UtilityService } from  '../../utility.service';
import { Router} from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../../auth.service';
@Component({
  selector: 'app-create-costcenter',
  templateUrl: './create-costcenter.component.html',
  styleUrls: ['./create-costcenter.component.css']
})
export class CreateCostcenterComponent implements OnInit {
  costcenter = new Costcenter();
  costcenterdata : any = {}
  submitted = false;
  message: string;
  costcenterForm: FormGroup;
  public isupdate = false;
public FormName = "Add Cost Center";
poapproverusers:User[];
poreviewerusers:User[];
poapproveruserslevel1:User[];
  constructor(
    private costcenterService:CostcenterService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private util:UtilityService, 
    public toastr: ToastrManager,
    private location: Location,
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.costcenter.active = 1;
    this.getUserByroleByApprover();
    this.getUserByroleByReviewer();
    this.getUserByroleByApproverLevel1();
    if(this.route.snapshot.paramMap.get('costcenterid') != null)
			{
        const costcenterid = +this.route.snapshot.paramMap.get('costcenterid');
				 if(costcenterid > 0)
				 {
					 this.getCostcenter(costcenterid);
				 }
				 this.isupdate = true;
				 this.FormName = "Update Cost Center";
				 
      }
      this.costcenterForm = this.formBuilder.group({			
        costcentername: [this.costcenter.costcentername,[Validators.required, Validators.required]],
        polevel1amount: [this.costcenter.polevel1amount,[Validators.required, Validators.required]],
        poreviewerid: [this.costcenter.poreviewerid,[Validators.required, Validators.required]],
        poapproverid: [this.costcenter.poapproverid,[Validators.required, Validators.required]],
        poapproveridlevel1:[this.costcenter.poapproveridlevel1,[Validators.required, Validators.required]],
        remarks: [this.costcenter.remarks,[Validators.required, Validators.required]],
        active: [this.costcenter.active,[Validators.required, Validators.required]]
      });	
  }

   // convenience getter for easy access to form fields
get f() {
  return this.costcenterForm.controls
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.costcenterForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.updateCostCenter();
    }
    else{
      this.addCostCenter();
    }
  }
}

public addCostCenter() {
  this.costcenterdata = this.costcenter;
  this.costcenterdata.createdby = this.auth.currentUserValue.userid

 this.costcenterService.addCostCenter(this.costcenterdata).subscribe(() => 
 { 
 this.util.showSuccess("Cost center added successfully.");
 this.router.navigate(['/costcenter-list']);
 });
}

public updateCostCenter() {
    //this.submitted = true;
    this.submitted = true;
    this.costcenterdata = this.costcenter;
    this.costcenterdata.modifiedby = this.auth.currentUserValue.userid;
    this.costcenterdata.modifiedon = Date.now();
    this.costcenterService.updateCostCenter(this.costcenterdata)
        .subscribe(() => 
      { 
      this.util.showSuccess("Cost center update successfully.");
        this.router.navigate(['/costcenter-list']);
      });
}

getCostcenter(costcenterid) {
  return this.costcenterService.getCostcenter(costcenterid)
             .subscribe(
               costcenter => {
                console.log(costcenter);
                this.costcenter = costcenter
               }
              );
}
getUserByroleByApprover() {
  return this.userService.getUserByroleByApprover()
             .subscribe(
              poapproverusers => {
                this.poapproverusers = poapproverusers
               }
              );
  }
  getUserByroleByApproverLevel1() {
    return this.userService.getUserByroleByApproverLevel2()
               .subscribe(
                poapproveruserslevel1 => {
                  this.poapproveruserslevel1 = poapproveruserslevel1
                 }
                );
    }
  getUserByroleByReviewer() {
    return this.userService.getUserByroleByReviewer()
               .subscribe(
                poreviewerusers => {
                  this.poreviewerusers = poreviewerusers
                 }
                );
    }
   
    
}
